import React, { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer"; 
import { Link } from "react-router-dom";
import "./FAQ.css";

class Terms extends Component {
  render() {
    return (
      <div>
        <Header />
      {/* Hero Section */}
      <div className="terms-hero" >
          <div className="faq-hero-content">
            <h1>Terms & Conditions</h1>
            <p>
              <Link to="/" className="breadcrumb-home">Home</Link> /{" "}
              <span className="breadcrumb-current">Terms</span>
            </p>
          </div>
        </div>
        
        {/* FAQ Section */}
        <div className="bg-black">
          <div className="container-fluid">
            <div className="row">
              <div className="pt-5 col-lg-8 offset-lg-2">
                <div className="text-light" style={{ fontSize: "18px" }}>
                 
                  
                  <p>
                   <b>1.0</b> These General Terms and Conditions of Rauxmac 
  Integrated Concepts for the use of its Wealth Cultivation System software, 
  The Wealth System (hereinafter referred to as &ldquo;TWS&rdquo;), as well as providing the 
  storage space for storing data required for wealth cultivation and the data 
  created by the software during task performance and its other use by users.
                  </p>
                  <p>
  <b>1.1</b> To govern the access to and use of 
  the Services of the software and all transactions incidental thereto, which are 
  offered online via the website, www.wealthsystem.net, or its downloadable App 
  on the internet for the purpose of wealth cultivation via investment of time, 
  data, persuasion ability, and access fee payment to generate system tasks. 
  Performance of tasks by users upon signup attracts system monetary rewards. 
  Rewards can be cashed out by users upon reaching the system&rsquo;s minimal 
  withdrawal threshold. Every user should establish a business capable of 
  employing not less than three persons, with GPRS images uploaded as evidence of 
  compliance, as a payback to society upon receipt of an amount in excess of 
  twenty million naira or its dollar equivalent from the Wealth System platform. 
  The system reserves the right to suspend temporarily the accounts of 
  non-complying users one month after notification or permanently after three 
  months upon notification.
                   </p>

                    <p>
                      <b>2.0</b>  The contracting parties are all forms of users on one end and Rauxmac 
                      Integrated Concepts, being the legal owner of The Wealth System at the other 
                       end.  
                       </p>
                    <p>
                      <b>2.1</b> Users are individuals who are up to eighteen years of age from every part 
                      of the world. 
                    </p>
                    <p>
                      <b>3.0</b> The contract language is English.
                    </p>
                    <p>
  <b>4.0</b> Please read these GTC carefully before using the Services, as your use of 
  the Services, which includes access fee payment and or your request for any of 
  our services, whichever comes first, shall be construed as your acceptance of 
  the terms of the GTC. Your acceptance of the GTC shall be construed as your 
  agreement to be bound by the terms of the GTC with respect to your access 
  and use of the Services. No other terms or conditions shall be of any force or 
  effect unless otherwise specifically agreed upon by The Wealth System admin 
  in writing, duly executed by an authorized officer of Rauxmac Integrated 
  Concepts, being the legal owner of the application.
</p>
<p>
  <b>5.0</b>  The Wealth System shall not reward users who 
  choose to perform system tasks without first paying the investment realm access 
  fee, as the latter should come first. No un-received cultivation rewards shall be 
  binding upon Rauxmac Integrated Concepts until payment for the access fee is made 
  with confirmation and the task performed. Thereafter, the provision/conveyance 
  of the right of use of the software shall be transferred to the user.
</p>
                 
                    <p>
                      <b>5.1</b> Unless otherwise agreed by The Wealth System in writing, the GTC and the 
                          other provisions, including but not limited to the Permitted Use Policy for TWS 
                          services, the Privacy Policy and the Service Level Agreement referred to in 
                         these GTC, as such may be amended by TWS unilaterally from time to time (the 
                      “Ancillary Documents and Policies”) together with any terms on The Wealth System&apos;s 
                      email confirmation (the “Subscription Confirmation”) constitute the entire 
                         agreement between users and TWS, and shall supersede any and all prior 
                         written or oral agreements, offers, or other representations with respect to the 
                       Services.
                      </p>

                    <p>
                      <b>5.2</b>   In the event of conflict between the terms of these GTCs, the Ancillary 
Documents and Policies and the Investment Realm Access Fee Payment 
Confirmation, the order of precedence shall be as follows:  
                      <ul>
                        <li>Investment Realm Access Fee Payment Confirmation</li>
                        <li>These General Terms and Conditions</li>
                        <li>Permitted Use Policy for TWS Services</li>
                        <li>The Service Level Agreement</li>
                      </ul>
                    </p>
                    <p>
                      <b>6.0</b> Subscription involves the creation of user account by accepting GTC and 
signing up, which is required for the use of the software. Upon successful 
registration, the registered email address or username and password is 
required to access the application subsequently. 
                    </p>
                    <p>
                      <b>6.1</b>  For purpose of wealth cultivation, users who are signed in with their user 
accounts can perform the assigned tasked and migrate to higher investment 
realm in pursuance of higher cultivation for a higher system rewards using the 
software. 
                    </p>
                  
                </div>
                <br /><br />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Terms;
